import { render } from "./clean.vue?vue&type=template&id=4befd246"
import script from "./clean.vue?vue&type=script&lang=js"
export * from "./clean.vue?vue&type=script&lang=js"

import "./clean.vue?vue&type=style&index=0&id=4befd246&lang=scss"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__